import styled from 'styled-components';

export const FAQMenuButton = styled.div<{
  styles: any;
}>`
  ${({ styles }) => styles};
`;
